import {
  requestAddItemToCart,
  RequestAddItemToCartAction,
  requestRemoveItemFromCart,
  RequestRemoveItemFromCartAction,
} from '../../redux/actions/cart';
import { getLicenseString } from '../../redux/helpers/license';
import { CartEvent, EventCategory, EventDefinition, EventsMap } from '../types';

export function licenseLineItemToLicenseStr(lineItem: GQL.ILicenseLineItem) {
  return lineItem.license!.usages!.map((usage) => usage.components!.map((c) => c.name)).join(', ');
}

const addItemToCartEvent: EventDefinition<RequestAddItemToCartAction> = ({
  payload: {
    currencyCode,
    lineItem,
  },
}) => {
  const license = getLicenseString(lineItem.terms);

  return {
    event: CartEvent.AddToCart,
    category: EventCategory.Cart,
    action: CartEvent.AddToCart,
    label: `${lineItem.track.title} (${license})`,
    ecommerce: {
      currencyCode,
      add: {
        products: [{
          name: lineItem.track.title,
          id: lineItem.track.internal_id,
          price: lineItem.track.price,
          brand: lineItem.track.artist!.name,
          category: 'License',
          variant: license,
          quantity: 1,
          list: window.location.pathname,
        }],
      },
    },
  };
};

const removeItemFromCartEvent: EventDefinition<RequestRemoveItemFromCartAction> = ({
  payload: {
    currencyCode,
    lineItem,
  },
}) => {
  const license = licenseLineItemToLicenseStr(lineItem);

  return {
    event: CartEvent.RemoveFromCart,
    category: EventCategory.Cart,
    action: CartEvent.RemoveFromCart,
    label: `${lineItem.track!.title} (${license})`,
    ecommerce: {
      currencyCode,
      remove: {
        products: [{
          name: lineItem.track!.title,
          id: lineItem.track!.internal_id,
          price: lineItem.track!.price,
          brand: lineItem.track!.artist!.name,
          category: 'License',
          variant: license,
          quantity: 1,
        }],
      },
    },
  };
};

export const cartEventsMap: EventsMap = {
  [requestAddItemToCart.type]: addItemToCartEvent,
  [requestRemoveItemFromCart.type]: removeItemFromCartEvent,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/events/cart.ts